/*! Debora Cards – shared renderer (chat + upsell) — v2 robust cart refresh */
(function(){
  if (window.DeboraCards) return;

  var STATE = {
    addToCartLabel: 'Aggiungi al Carrello',
    availabilityLabel: 'Disponibilità immediata',
    showVendor: true,
    sfToken: '',
    market: '',
    lang: ''
  };

  var DEBUG = !!window.DEBORA_CARDS_DEBUG;
  function log(){ if (DEBUG) console.log.apply(console, ['[DeboraCards]'].concat([].slice.call(arguments))); }

  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"']/g, m => m==='&'?'&amp;':m==='<'?'&lt;':m==='>'?'&gt;':m==='"'?'&quot;':'&#39;'); }
  function moneySpan(amount, currency){
    var cents = Math.round(Number(amount||0));
    var cur = currency ? ' data-currency="'+esc(currency)+'"' : '';
    return '<span class="money" data-money-amount="'+cents+'"'+cur+'></span>';
  }
  function formatMoneySpansFallback(root){
    try{
      var container = root || document;
      var spans = container.querySelectorAll('.debora-card .money');
      if (!spans.length) return;
      var curr = (window.Shopify && Shopify.currency && (Shopify.currency.active || Shopify.currency.shopCurrency)) || 'EUR';
      var lang = (document.documentElement && document.documentElement.lang) || (window.Shopify && Shopify.locale) || 'it';
      var nf = new Intl.NumberFormat(String(lang).replace('_','-'), { style:'currency', currency: curr });
      spans.forEach(function(s){
        if (s.textContent && s.textContent.trim()) return;
        var cents = Number(s.getAttribute('data-money-amount')||'0');
        s.textContent = nf.format(cents/100);
      });
    }catch(e){}
  }

  function detectCurrency(code){
    if (code) return code;
    if (window.Shopify && Shopify.currency) {
      if (Shopify.currency.active) return Shopify.currency.active;
      if (Shopify.currency.shopCurrency) return Shopify.currency.shopCurrency;
    }
    return 'EUR';
  }

  function formatMoney(cents, currency){
    var curr = detectCurrency(currency);
    var amount = Number(cents || 0) / 100;
    try {
      var lang = (document.documentElement && document.documentElement.lang) || (window.Shopify && Shopify.locale) || 'it';
      return new Intl.NumberFormat(String(lang).replace('_','-'), { style:'currency', currency: curr }).format(amount);
    } catch(err) {
      return curr + ' ' + amount.toFixed(2);
    }
  }

  var PRODUCT_CACHE = {};
  var SLIDER_UID = 0;

  function fetchProductJson(handle){
    if (!handle) return Promise.resolve(null);
    var key = String(handle || '').toLowerCase();
    if (!key) return Promise.resolve(null);
    if (PRODUCT_CACHE[key]) return PRODUCT_CACHE[key];
    PRODUCT_CACHE[key] = fetch('/products/' + encodeURIComponent(key) + '.js', { credentials: 'same-origin' })
      .then(function(res){ return res && res.ok ? res.json() : null; })
      .catch(function(){ return null; });
    return PRODUCT_CACHE[key];
  }

  function computeVariantStock(variants){
    var list = Array.isArray(variants) ? variants : [];
    var total = 0;
    for (var i = 0; i < list.length; i += 1){
      var qty = Number(list[i] && list[i].inventory_quantity);
      if (Number.isFinite(qty)) total += qty;
    }
    return total;
  }

  function deriveStock(p){
    if (!p) return null;
    if (Number.isFinite(p.stock)) return Number(p.stock);
    if (Number.isFinite(p.total_inventory)) return Number(p.total_inventory);
    if (Number.isFinite(p.inventory_quantity)) return Number(p.inventory_quantity);
    if (Array.isArray(p.variants)) {
      var sum = computeVariantStock(p.variants);
      if (Number.isFinite(sum)) return sum;
    }
    return null;
  }

  function renderStockInfo(stock, lang){
    if (!Number.isFinite(stock)) return '';
    var qty = Math.max(0, Math.round(Number(stock)));
    var lang2 = (lang || 'it').slice(0,2).toLowerCase();
    var dot = '#dc3545';
    var label;
    if (qty > 9) {
      dot = '#28a745';
      label = lang2 === 'it' ? 'Disponibilità Immediata' : 'Available';
    } else if (qty > 0) {
      dot = '#fd7e14';
      label = lang2 === 'it'
        ? 'Solo ' + qty + ' Disponibili'
        : 'Only ' + qty + ' Available';
    } else {
      label = lang2 === 'it' ? 'Stock Esaurito' : 'Out of Stock';
    }

    return ''+
      '<div class="product-item__stock-info" data-stock="'+qty+'">'+
        '<span class="product-item__stock-dot" aria-hidden="true" style="background:'+dot+';"></span>'+
        '<span class="product-item__stock-label">'+esc(label)+'</span>'+
      '</div>';
  }

  function extractTextList(value){
    if (!value && value !== 0) return [];
    if (Array.isArray(value)) {
      var arr = [];
      value.forEach(function(v){ arr = arr.concat(extractTextList(v)); });
      return arr;
    }
    if (typeof value === 'object') {
      if (value && typeof value.value !== 'undefined') return extractTextList(value.value);
      if (value && typeof value.text !== 'undefined') return extractTextList(value.text);
      if (value && typeof value.values !== 'undefined') return extractTextList(value.values);
      var out = [];
      Object.keys(value || {}).forEach(function(key){
        if (key === 'key' || key === 'namespace' || key === '__typename') return;
        if (typeof value[key] === 'function') return;
        out = out.concat(extractTextList(value[key]));
      });
      return out;
    }
    return String(value || '').split(/[;,/]+/).map(function(v){ return v.trim(); }).filter(Boolean);
  }

  function appendUnique(target, list){
    if (!Array.isArray(target)) return [];
    var arr = Array.isArray(list) ? list : (typeof list === 'undefined' ? [] : [list]);
    arr.forEach(function(item){
      var str = String(item == null ? '' : item).trim();
      if (!str) return;
      var lower = str.toLowerCase();
      for (var i = 0; i < target.length; i += 1){
        if (String(target[i] || '').toLowerCase() === lower) return;
      }
      target.push(str);
    });
    return target;
  }

  function collectMetaStrings(source, keys){
    var out = [];
    if (!source) return out;
    var normalized = (keys || []).map(function(k){ return String(k || '').toLowerCase(); });

    function pushValue(val){ appendUnique(out, extractTextList(val)); }

    if (Array.isArray(source)) {
      source.forEach(function(entry){
        if (!entry) return;
        var key = String(entry.key || '').toLowerCase();
        var namespace = String(entry.namespace || '').toLowerCase();
        var full = namespace ? namespace + '.' + key : key;
        var payload = (typeof entry.value !== 'undefined') ? entry.value :
                      (typeof entry.text !== 'undefined') ? entry.text :
                      (typeof entry.content !== 'undefined') ? entry.content :
                      (typeof entry.parsedValue !== 'undefined') ? entry.parsedValue : entry;

        normalized.forEach(function(target){
          if (target === key || target === full) pushValue(payload);
        });

        if (entry && typeof entry.value === 'object' && entry.value) {
          normalized.forEach(function(target){
            var node = entry.value;
            var parts = target.split('.');
            for (var i = 0; i < parts.length; i += 1){
              if (!node || typeof node !== 'object') { node = undefined; break; }
              var part = parts[i];
              if (!(part in node) && (part.toLowerCase() in node)) part = part.toLowerCase();
              node = node[part];
            }
            if (typeof node !== 'undefined') pushValue(node);
          });
        }
      });
    } else if (typeof source === 'object') {
      normalized.forEach(function(target){
        var node = source;
        var parts = target.split('.');
        for (var i = 0; i < parts.length; i += 1){
          if (!node || typeof node !== 'object') { node = undefined; break; }
          var part = parts[i];
          if (!(part in node) && (part.toLowerCase() in node)) part = part.toLowerCase();
          node = node[part];
        }
        if (typeof node !== 'undefined') pushValue(node);
      });
    }

    return out;
  }

  function renderPlaceGrapes(p){
    if (!p) return '';
    var grapes = [];
    appendUnique(grapes, extractTextList(p.grapes));
    if (!grapes.length && p.grape) appendUnique(grapes, extractTextList(p.grape));

    var metaSources = [p.metafields, p.meta, p.metadata, p.attributes];
    metaSources.forEach(function(source){
      appendUnique(grapes, collectMetaStrings(source, [
        'custom.grapes','custom.grape','grapes','grape','vino.grape','wine.grape','uva','vitigno'
      ]));
    });

    var grapeText = grapes.slice(0, 3).join(', ');

    var locations = [];
    ['appellation','place','subregion','macro','region','country','area','territory','location'].forEach(function(key){
      appendUnique(locations, extractTextList(p[key]));
    });
    if (p.subtitle) appendUnique(locations, extractTextList(p.subtitle));
    metaSources.forEach(function(source){
      appendUnique(locations, collectMetaStrings(source, [
        'custom.appellation','custom.place','custom.subregion','custom.region','custom.country','custom.territory','custom.area','appellation','place','subregion','region','country','denominazione','denomination'
      ]));
    });

    var locationText = locations.slice(0, 3).join(', ');

    var bits = [];
    if (grapeText) bits.push(grapeText);
    if (locationText) bits.push(locationText);
    if (!bits.length) return '';
    var safe = bits.map(esc).join(' • ');
    return '<div class="place-grapes">'+safe+'</div>';
  }

  function updateCardStockDisplay(card, qty, lang2){
    if (!card || !Number.isFinite(qty)) return;
    var html = renderStockInfo(qty, lang2);
    if (!html) return;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var node = wrapper.firstChild;
    if (!node) return;
    var existing = card.querySelector('.product-item__stock-info');
    if (existing) existing.replaceWith(node);
    else {
      var txt = card.querySelector('.txt');
      if (txt) txt.appendChild(node);
    }
    var fallback = card.querySelector('.availability');
    if (fallback) fallback.remove();
  }

  function fetchInventoryForHandles(handles, opts){
    opts = opts || {};
    var token = opts.sfToken || opts.token || opts.storefrontToken;
    if (!token || !handles || !handles.length) return Promise.resolve({});
    var shop = (opts.shop) || (window.Shopify && Shopify.shop) || location.host || location.hostname;
    var batches = [];
    for (var i = 0; i < handles.length; i += 8) {
      batches.push(handles.slice(i, i + 8));
    }
    var results = {};

    function doBatch(batch){
      var aliasFields = batch.map(function(handle, idx){
        return 'p'+idx+': product(handle:'+JSON.stringify(handle)+'){handle totalInventory variants(first:100){edges{node{quantityAvailable}}}}';
      }).join('\n');
      var query = 'query Inventory {\n'+aliasFields+'\n}';
      return fetch('https://'+shop+'/api/2024-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query }),
        credentials: 'same-origin'
      })
      .then(function(res){ return res && res.ok ? res.json() : null; })
      .then(function(json){
        var data = json && json.data;
        if (!data) return;
        batch.forEach(function(handle, idx){
          var key = String(handle || '').toLowerCase();
          var node = data['p'+idx];
          if (!node) return;
          var total = Number(node.totalInventory);
          if (!Number.isFinite(total)) {
            total = 0;
            var edges = (node.variants && node.variants.edges) || [];
            edges.forEach(function(edge){
              var qty = Number(edge && edge.node && edge.node.quantityAvailable);
              if (Number.isFinite(qty)) total += qty;
            });
            if (!Number.isFinite(total)) total = null;
          }
          if (Number.isFinite(total)) results[key] = total;
        });
      })
      .catch(function(){ return null; });
    }

    return batches.reduce(function(prev, batch){
      return prev.then(function(){ return doBatch(batch); });
    }, Promise.resolve()).then(function(){ return results; });
  }

  function ensureAccurateStock(root, picks, opts){
    if (!root) return;
    opts = opts || {};
    var lang2 = (opts.lang || opts.locale || STATE.lang || (document.documentElement && document.documentElement.lang) || 'it').slice(0,2).toLowerCase();
    var cards = root.querySelectorAll('.debora-card');
    if (!cards.length) return;

    var byHandle = {};
    cards.forEach(function(card, idx){
      var pick = Array.isArray(picks) ? picks[idx] : null;
      var handle = ((pick && pick.handle) || card.getAttribute('data-handle') || '').toLowerCase();
      if (!handle) return;
      if (!byHandle[handle]) byHandle[handle] = [];
      byHandle[handle].push({ card: card, pick: pick });
      var existing = deriveStock(pick);
      if (Number.isFinite(existing)) updateCardStockDisplay(card, existing, lang2);
    });

    var handles = Object.keys(byHandle);
    if (!handles.length) return;

    var token = opts.sfToken || opts.token || opts.storefrontToken || STATE.sfToken ||
                (window.__debora && (window.__debora.token || window.__debora.sfToken)) || '';
    var fetchOpts = {
      sfToken: token,
      token: token,
      storefrontToken: token,
      shop: opts.shop,
      market: opts.market || opts.country || STATE.market || (window.__marketCode || '')
    };

    fetchInventoryForHandles(handles, fetchOpts).then(function(map){
      var missing = [];
      handles.forEach(function(handle){
        var qty = map[String(handle || '').toLowerCase()];
        if (!Number.isFinite(qty)) { missing.push(handle); return; }
        var list = byHandle[handle] || [];
        list.forEach(function(entry){
          if (entry.pick) {
            entry.pick.stock = qty;
            entry.pick.total_inventory = qty;
          }
          updateCardStockDisplay(entry.card, qty, lang2);
        });
      });

      if (!missing.length) return;
      missing.forEach(function(handle){
        fetchProductJson(handle).then(function(prod){
          if (!prod) return;
          var total = computeVariantStock(prod.variants);
          if (!Number.isFinite(total)) return;
          var list = byHandle[handle] || [];
          list.forEach(function(entry){
            if (entry.pick) {
              entry.pick.stock = total;
              entry.pick.total_inventory = total;
            }
            updateCardStockDisplay(entry.card, total, lang2);
          });
        }).catch(function(){});
      });
    }).catch(function(){
      handles.forEach(function(handle){
        fetchProductJson(handle).then(function(prod){
          if (!prod) return;
          var total = computeVariantStock(prod.variants);
          if (!Number.isFinite(total)) return;
          var list = byHandle[handle] || [];
          list.forEach(function(entry){
            if (entry.pick) {
              entry.pick.stock = total;
              entry.pick.total_inventory = total;
            }
            updateCardStockDisplay(entry.card, total, lang2);
          });
        }).catch(function(){});
      });
    });
  }

  function resolveImage(product, variant){
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (product && product.featured_image) return product.featured_image;
    if (product && Array.isArray(product.images) && product.images[0]) return product.images[0];
    return '';
  }

  var CART_POPUP_CACHE = null;

  function getCartPopupParts(){
    if (typeof document === 'undefined') return null;
    var root = document.getElementById('debora-cart-popup-upsell') || document.getElementById('debora-cart-popup');
    if (!root) { CART_POPUP_CACHE = null; return null; }
    if (CART_POPUP_CACHE && CART_POPUP_CACHE.root === root && root.isConnected) return CART_POPUP_CACHE;
    var body = root.querySelector('.debora-cart-popup__body');
    var template = document.getElementById('debora-cart-popup-template-upsell') || document.getElementById('debora-cart-popup-template');
    if (!body || !template) return null;
    CART_POPUP_CACHE = { root: root, body: body, template: template };
    return CART_POPUP_CACHE;
  }

  function hideCartPopup(parts){
    var popup = parts || getCartPopupParts();
    if (!popup || !popup.root) return;
    if (popup.root._hideTimer) {
      clearTimeout(popup.root._hideTimer);
      popup.root._hideTimer = null;
    }
    popup.root.classList.remove('is-visible');
    setTimeout(function(){
      if (!popup.root.classList.contains('is-visible')) {
        popup.root.hidden = true;
        if (popup.body) popup.body.innerHTML = '';
      }
    }, 220);
  }

  function showCartPopup(product, variant, qty, cart){
    var popup = getCartPopupParts();
    if (!popup || !popup.template || !popup.body) return;

    var tpl = popup.template.content ? popup.template.content.cloneNode(true) : null;
    if (!tpl) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = popup.template.innerHTML || '';
      tpl = document.createDocumentFragment();
      while (wrapper.firstChild) tpl.appendChild(wrapper.firstChild);
    }

    var link = tpl.querySelector('[data-role="product-link"]');
    var titleLink = tpl.querySelector('[data-role="title-link"]');
    var titleText = tpl.querySelector('[data-role="title-text"]');
    var variantNode = tpl.querySelector('[data-role="variant-text"]');
    var imageEl = tpl.querySelector('[data-role="product-image"]');
    var countNode = tpl.querySelector('[data-cart-count]');
    var totalNode = tpl.querySelector('[data-cart-total]');

    var url = (product && product.url) || ('/products/' + (product && product.handle ? product.handle : ''));
    if (link) link.href = url;
    if (titleLink) titleLink.href = url;
    if (titleText) titleText.textContent = product && product.title ? product.title : '';

    if (variantNode) {
      var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
      variantNode.textContent = variantTitle;
      if (!variantTitle) variantNode.style.display = 'none';
    }

    if (imageEl) {
      var imgSrc = resolveImage(product, variant);
      if (imgSrc) {
        imageEl.src = imgSrc;
        imageEl.alt = product && product.title ? product.title : '';
      } else {
        imageEl.remove();
      }
    }

    if (countNode && cart) {
      var count = Number(cart.item_count || 0);
      countNode.textContent = String(count);
      countNode.setAttribute('data-cart-count', String(count));
    }
    if (totalNode && cart) {
      var formatted = formatMoney(cart.total_price || 0, cart.currency);
      totalNode.textContent = formatted;
      totalNode.setAttribute('data-cart-total', String(cart.total_price || 0));
    }

    popup.body.innerHTML = '';
    popup.body.appendChild(tpl);
    popup.root.hidden = false;
    popup.root.classList.add('is-visible');
    if (popup.root._hideTimer) clearTimeout(popup.root._hideTimer);
    popup.root._hideTimer = setTimeout(function(){ hideCartPopup(popup); }, 4200);
  }

  /* ------------------------------------------
     CART REFRESH HELPERS
  ------------------------------------------ */
  function detectCartSections(){
    // Try to discover all cart-related section IDs currently in DOM
    var ids = new Set();

    // Common Dawn / custom
    ['cart-drawer','cart-icon-bubble','cart-notification','cart-items','main-cart-items','cart-free-shipping'].forEach(function(id){ ids.add(id); });

    // Anything with cart-ish id
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function(el){
      var id = el.id.replace('shopify-section-','');
      if (/cart|drawer|bubble|notification/i.test(id)) ids.add(id);
    });

    // Themes using data-section-id
    document.querySelectorAll('[data-section-id]').forEach(function(el){
      var id = el.getAttribute('data-section-id');
      if (id && /cart|drawer|bubble|notification/i.test(id)) ids.add(id);
    });

    // Filter empty and make array
    var out = Array.from(ids).filter(Boolean);
    log('detected sections:', out);
    return out;
  }

  function swapSectionsFromMap(map){
    if (!map) return;
    Object.keys(map).forEach(function(id){
      var html = map[id];
      if (!html) return;
      var host = document.querySelector('#shopify-section-'+id) ||
                 document.querySelector('[data-section-id="'+id+'"]') ||
                 document.getElementById(id);
      if (host) {
        host.innerHTML = html;
        log('updated section', id);
      }
    });
  }

  function openCartUI(){
    try{
      // Dawn ≥ v8
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl){
        if (typeof drawerEl.open === 'function') { drawerEl.open(); return; }
        drawerEl.setAttribute('open','');
        drawerEl.classList.add('is-open');
      }
      // Cart notification style
      var notif = document.querySelector('cart-notification');
      if (notif){
        if (typeof notif.open === 'function') notif.open();
        notif.setAttribute('open','');
      }
      // Buttons that toggle drawer
      var toggler = document.querySelector('[data-cart-toggle],[aria-controls="CartDrawer"],a[href="#CartDrawer"]');
      if (toggler) toggler.click();
    }catch(e){}
  }

  async function refreshCartUI(opts){
    opts = opts || {};
    var sections = opts.sections || detectCartSections();
    var path = location.pathname.split('?')[0];
    var cart = null;

    try{
      // Update badge/count quickly
      cart = await fetch('/cart.js', { credentials:'same-origin', headers:{'Cache-Control':'no-store'} }).then(r=>r.json());
      var count = cart.item_count || 0;
      document.querySelectorAll('#CartCount,.cart-count-bubble,[data-cart-count]').forEach(function(el){
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(count));
        var badge = el.querySelector('.text');
        if (badge) badge.textContent = String(count);
        if (/^\d+$/.test((el.textContent||'').trim())) el.textContent = String(count);
      });

      // Try Section Rendering API on current page
      if (sections.length){
        var url = path + '?sections=' + sections.join(',');
        var secJson = await fetch(url, { credentials:'same-origin', headers:{'Cache-Control':'no-store'} }).then(r => r.ok ? r.json() : null).catch(()=>null);
        if (secJson) swapSectionsFromMap(secJson);
      }

      // Broadcast a bunch of common events
      document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail:{ cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh:end', { detail:{ cart: cart } }));
      document.dispatchEvent(new Event('debora:cart:sections-refreshed'));

      // Open the drawer if it exists
      openCartUI();

      // Last resort if on /cart and we couldn't update
      if (path.replace(/\/+$/,'') === '/cart' && !document.querySelector('#main-cart-items, #cart-items')) {
        location.reload();
      }

      return cart;
    }catch(e){
      log('refreshCartUI error', e);
      if (location.pathname.replace(/\/+$/,'') === '/cart') location.reload();
      return cart;
    }
  }

  // 👉 New: add with sections and update immediately from the response
  async function addToCartByHandle(handle, qty){
    qty = Math.max(1, Number(qty||1));

    // Discover sections up front so /cart/add.js can return them directly
    var sections = detectCartSections();
    var sectionsParam = sections.length ? ('?sections=' + encodeURIComponent(sections.join(','))) : '';
    var cartData = null;

    try{
      var pr = await fetch('/products/'+encodeURIComponent(handle)+'.js', { credentials:'same-origin', headers:{'Cache-Control':'no-store'} });
      var pj = await pr.json();
      var v = (pj.variants||[]).find(v => v && v.available) || (pj.variants||[])[0];
      if (!v) { alert('Out of stock'); return null; }

      var res = await fetch('/cart/add.js' + sectionsParam, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest', 'Accept':'application/json' },
        body: JSON.stringify({ id: v.id, quantity: qty }),
        credentials:'same-origin'
      });

      var data = await res.json().catch(function(){ return null; });

      // If theme returned sections HTML, inject it now (Dawn behaviour)
      if (data && data.sections) {
        swapSectionsFromMap(data.sections);
      }

      // Fire theme-friendly events
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: pj, variant: v, quantity: qty } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:add', { detail:{ id: v.id, quantity: qty } }));

      // Open drawer / notification
      openCartUI();

      // As a safety net, also do our generic refresh pass
      cartData = await refreshCartUI({ sections: sections });
      showCartPopup(pj, v, qty, cartData);

    }catch(e){
      console.warn('[DeboraCards] ATC failed', e);
      // Fallback: still try to refresh
      cartData = await refreshCartUI({ sections: sections });
    }

    // Ask theme money formatter to run; else fallback
    document.dispatchEvent(new Event('money:update', { bubbles:true }));
    setTimeout(function(){ formatMoneySpansFallback(document); }, 60);

    return cartData;
  }

  /* ------------------------------------------
     OPTIONAL: title localization (unchanged)
  ------------------------------------------ */
  async function localizeTitles(picks, opts){
    try{
      if (!Array.isArray(picks) || !picks.length) return picks;
      var token = (opts && opts.token) || (window.__debora && (window.__debora.token || window.__debora.sfToken)) || '';
      if (!token) return picks;

      var handles = Array.from(new Set(picks.map(p => p && p.handle).filter(Boolean)));
      if (!handles.length) return picks;

      var shopHost = (window.Shopify && Shopify.shop) || location.host;
      var lang = ((opts && opts.lang) || (window.Shopify && Shopify.locale) || 'it').slice(0,2).toUpperCase();
      var country = ((opts && opts.country) || (window.__marketCode || 'IT')).toUpperCase();

      for (var i=0;i<handles.length;i+=20){
        var batch = handles.slice(i,i+20);
        var fields = batch.map(function(h,ix){ return 'p'+ix+': product(handle:'+JSON.stringify(h)+'){handle title}'; }).join('\n');
        var gql = 'query Localize($country:CountryCode!, $language:LanguageCode!) @inContext(country:$country, language:$language){\n'+fields+'\n}';
        var res = await fetch('https://'+shopHost+'/api/2024-07/graphql.json',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':token},
          body: JSON.stringify({ query: gql, variables: { country: country, language: lang } }),
          credentials:'same-origin'
        });
        var j = await res.json().catch(function(){return null;});
        var data = (j && j.data) || {};
        Object.keys(data).forEach(function(k){
          var n = data[k];
          if (n && n.handle && n.title){
            var pk = picks.find(p => p && p.handle === n.handle);
            if (pk) pk.title = n.title;
          }
        });
      }
    }catch(e){ console.warn('[DeboraCards] localizeTitles failed', e); }
    return picks;
  }

  /* ------------------------------------------
     BADGES / RENDER / MOUNT
  ------------------------------------------ */
  function renderBadges(p, lang2){
    var out = [];
    var lang = (lang2||'it').slice(0,2).toLowerCase();
    function label(l, cls){ out.push('<span class="badge '+(cls||'badge--note')+'">'+esc(l)+'</span>'); }

    if (Array.isArray(p.badges)){
      p.badges.forEach(function(b){
        if (!b) return;
        if (typeof b === 'string') label(b);
        else if (b && b.text) label(String(b.text), String(b.theme||'badge--note'));
      });
    }
    var po = Number(p.percent_off||0);
    if (po >= 5) label('-'+Math.round(po)+'%', 'badge--sale');
    if (p.is_new) label(lang==='it'?'Novità':'New', 'badge--new');

    var stock = (typeof p.stock === 'number') ? p.stock : (p.inventory_quantity);
    var low = p.low_stock || (typeof stock === 'number' && stock > 0 && stock <= 5);
    if (low) label(lang==='it'?'Ultime unità':'Low stock', 'badge--low');

    return out.length ? '<div class="badges">'+out.join('')+'</div>' : '';
  }
  function pill(s){ return '<span class="pill">'+esc(s)+'</span>'; }

  function render(picks, opts){
    opts = opts || {};
    var showVendor = !!(opts.showVendor != null ? opts.showVendor : STATE.showVendor);
    var addToCartLabel = String(opts.addToCartLabel || STATE.addToCartLabel || 'Add to cart');
    var availability = String(opts.availabilityLabel || STATE.availabilityLabel || '');
    var lang = (opts.lang || (document.documentElement && document.documentElement.lang) || 'it').slice(0,2).toLowerCase();

    var layout = String(opts.layout || '').toLowerCase();
    var slider = layout === 'slider';
    if (!slider && opts.slider != null) {
      if (typeof opts.slider === 'string') slider = /^(1|true)$/i.test(opts.slider);
      else slider = !!opts.slider;
    }

    var rootClasses = ['debora-picks'];
    if (slider) rootClasses.push('debora-picks--slider');
    if (opts.containerClass) {
      String(opts.containerClass).split(/\s+/).forEach(function(cls){
        if (!cls) return;
        rootClasses.push(cls.replace(/[^a-zA-Z0-9_-]/g, ''));
      });
    }
    var rootClassAttr = rootClasses.filter(Boolean).join(' ');

    var cardsHtml = picks.map(function(p){
      if (!p) return '';
      var url = p.url || ('/products/'+(p.handle||''));
      var img = p.image ? (
        '<a class="card-img" href="'+esc(url)+'"><img loading="lazy" src="'+esc(p.image)+'" alt="'+esc(p.title||'')+'"></a>'
      ) : '';
      var vendor = showVendor && p.vendor
        ? '<div class="vendor"><a href="/collections/vendors?q='+encodeURIComponent(p.vendor)+'">'+esc(p.vendor)+'</a></div>'
        : '';

      var placeGrapes = renderPlaceGrapes(p);
      var price = (typeof p.price_cents === 'number') ? '<div class="price">'+moneySpan(p.price_cents, p.currency)+'</div>' : '';
      var stockInfo = renderStockInfo(deriveStock(p), lang);
      var avail = (!stockInfo && availability) ? '<div class="availability">'+esc(availability)+'</div>' : '';

      var badges = renderBadges(p, lang);

      var colorHex = p.circle_color || p.color || p.wine_color;
      var colorBar = colorHex ? ('<div class="wine-color-bar-under"><span class="wine-color-bar" style="background:'+esc(colorHex)+';"></span></div>') : '';

      return (
        '<article class="debora-card" data-handle="'+esc(p.handle||'')+'">'+
          img+
          '<div class="txt">'+
            badges+
            colorBar+
            '<h3 class="ttl"><a href="'+esc(url)+'" style="color:inherit;text-decoration:none">'+esc(p.title||'')+'</a></h3>'+
            vendor+
            placeGrapes+
            price+
            stockInfo+
            avail+
          '</div>'+
          '<div class="actions"><button class="atc" data-debora-atc data-handle="'+esc(p.handle||'')+'"><span class="button__text">'+esc(addToCartLabel)+'</span></button></div>'+
        '</article>'
      );
    }).join('');

    if (!slider) {
      return '<div class="'+rootClassAttr+'">'+cardsHtml+'</div>';
    }

    var trackId = 'deboraSliderTrack_'+(++SLIDER_UID);
    var prevLabel = lang === 'it' ? 'Scorri indietro' : 'Scroll backward';
    var nextLabel = lang === 'it' ? 'Scorri avanti' : 'Scroll forward';

    var trackMarkup = '<div class="'+rootClassAttr+'" id="'+trackId+'" data-slider-track="1">'+cardsHtml+'</div>';

    return ''+
      '<div class="debora-slider" data-slider="1">'+
        '<button class="debora-slider__btn debora-slider__btn--prev" type="button" aria-label="'+esc(prevLabel)+'" aria-controls="'+trackId+'" data-slider-prev="'+trackId+'"><span aria-hidden="true">‹</span></button>'+
        trackMarkup+
        '<button class="debora-slider__btn debora-slider__btn--next" type="button" aria-label="'+esc(nextLabel)+'" aria-controls="'+trackId+'" data-slider-next="'+trackId+'"><span aria-hidden="true">›</span></button>'+
      '</div>';
  }

  function enhanceSlider(wrapper){
    if (!wrapper || wrapper.dataset.sliderEnhanced === '1') return;
    var track = wrapper.querySelector('.debora-picks--slider');
    if (!track) return;

    wrapper.dataset.sliderEnhanced = '1';

    var prev = wrapper.querySelector('.debora-slider__btn--prev');
    var next = wrapper.querySelector('.debora-slider__btn--next');

    function gapSize(){
      try {
        var style = window.getComputedStyle(track);
        var g = parseFloat(style.columnGap || style.gap || '0');
        return Number.isFinite(g) ? g : 0;
      } catch(_) { return 0; }
    }

    function cardWidth(){
      var card = track.querySelector('.debora-card');
      if (!card) return track.clientWidth || 0;
      return card.getBoundingClientRect().width || track.clientWidth || 0;
    }

    function scrollByDirection(dir){
      var delta = cardWidth() + gapSize();
      if (!delta) delta = track.clientWidth * 0.8;
      track.scrollBy({ left: dir * delta, behavior: 'smooth' });
    }

    var rafScheduled = false;
    function updateState(){
      rafScheduled = false;
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var left = track.scrollLeft;
      var atStart = left <= 2;
      var atEnd = left >= max - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      wrapper.classList.toggle('is-start', atStart);
      wrapper.classList.toggle('is-end', atEnd);
    }

    function scheduleUpdate(){
      if (rafScheduled) return;
      rafScheduled = true;
      (window.requestAnimationFrame || setTimeout)(updateState);
    }

    if (prev) prev.addEventListener('click', function(){ scrollByDirection(-1); scheduleUpdate(); });
    if (next) next.addEventListener('click', function(){ scrollByDirection(1); scheduleUpdate(); });

    track.addEventListener('scroll', scheduleUpdate, { passive:true });
    window.addEventListener('resize', scheduleUpdate);

    var imgs = track.querySelectorAll('img');
    imgs.forEach(function(img){
      if (img.complete) return;
      img.addEventListener('load', scheduleUpdate, { once:true });
    });

    scheduleUpdate();
    setTimeout(scheduleUpdate, 60);
  }

  function enhanceSliders(scope){
    if (!scope) scope = document;
    var wrappers = scope.querySelectorAll ? scope.querySelectorAll('.debora-slider[data-slider]') : [];
    wrappers.forEach(enhanceSlider);
  }

  function mount(rootOrSelector, picks, opts){
    var root = (typeof rootOrSelector === 'string') ? document.querySelector(rootOrSelector) : rootOrSelector;
    if (!root) return;
    if (!Array.isArray(picks)) picks = [];
    var options = opts || {};
    root.innerHTML = render(picks, options);
    enhanceSliders(root);
    document.dispatchEvent(new Event('money:update', { bubbles:true }));
    setTimeout(function(){
      formatMoneySpansFallback(root);
      ensureAccurateStock(root, picks, options);
      enhanceSliders(root);
    }, 60);
  }

  // Global click handler for ATC
  if (!window.__deboraCardsClickBound){
    window.__deboraCardsClickBound = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.debora-card .atc,[data-debora-atc]');
      if (!btn) return;
      var handle = btn.getAttribute('data-handle') || '';
      if (!handle) return;
      if (btn.dataset.deboraBusy === '1') { e.preventDefault(); return; }
      e.preventDefault();

      var animate = !!btn.closest('#debora-cart-upsell');
      if (animate) {
        btn.classList.remove('is-adding');
        void btn.offsetWidth;
        btn.classList.add('is-adding');
        setTimeout(function(){ btn.classList.remove('is-adding'); }, 700);
      }

      btn.dataset.deboraBusy = '1';
      btn.setAttribute('aria-busy', 'true');
      var canDisable = typeof btn.disabled !== 'undefined';
      if (canDisable) btn.disabled = true;

      addToCartByHandle(handle, 1)
        .catch(function(){ return null; })
        .finally(function(){
          delete btn.dataset.deboraBusy;
          btn.removeAttribute('aria-busy');
          if (canDisable) btn.disabled = false;
        });
    }, { passive:false });
  }

  if (!window.__deboraCartPopupCloseBound){
    window.__deboraCartPopupCloseBound = true;
    document.addEventListener('click', function(evt){
      var popup = getCartPopupParts();
      if (!popup || !popup.root) return;
      if (!popup.root.contains(evt.target)) return;
      if (evt.target.closest('.debora-cart-popup__close')) {
        evt.preventDefault();
        hideCartPopup(popup);
      }
    });
  }

  document.addEventListener('debora:cart:sections-refreshed', function(){ CART_POPUP_CACHE = null; });

  window.DeboraCards = {
    render: render,
    mount: mount,
    addToCartByHandle: addToCartByHandle,
    refreshCartUI: refreshCartUI,
    formatMoneySpansFallback: formatMoneySpansFallback,
    localizeTitles: localizeTitles,
    setDefaults: function(opts){
      if (!opts) return;
      if (opts.addToCartLabel) STATE.addToCartLabel = String(opts.addToCartLabel);
      if (opts.availabilityLabel) STATE.availabilityLabel = String(opts.availabilityLabel);
      if (typeof opts.showVendor === 'boolean') STATE.showVendor = !!opts.showVendor;
      if (opts.sfToken) STATE.sfToken = String(opts.sfToken);
      if (opts.market) STATE.market = String(opts.market);
      if (opts.lang) STATE.lang = String(opts.lang);
    }
  };
})();